import styled from 'styled-components'
import Flex from 'components/Flex'

export const Span = styled.span`
  color: red;
`

export const OtpDiv = styled(Flex)`
  margin-top: 10px;
  gap: 10px;
  width: 100%;
`

export const OTPHeading = styled.div`
  font-weight: 500;
  font-size: 1em;
  line-height: 18px;
  color: #4d566e;
`
export const InputGroup = styled(Flex)`
  gap: 10px;
`

export const OTPButton = styled.div`
  font-weight: 400;
  font-size: 1.0714285714285714em;
  line-height: 19px;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  color: #1b1f22;
  word-spacing: 1px;
  cursor: pointer;
`

export const OTPMessage = styled(Flex)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  gap: 10px;
  border-radius: 10px;
  padding: 8px;
  background: #eff8f4;
`
export const SpanBold = styled.span`
  font-weight: 500;
`
